// extracted by mini-css-extract-plugin
export default {"appContainer":"gF_K8mhw0i","main":"oDubHa9Mpy","dark":"IkFUVlJQyE"};